
    import { createSlice, PayloadAction } from '@reduxjs/toolkit'
    
    type TLeadState =  {
        data: [],
        perPage: number,
        currentPage: number,
        totalPage: number,
        searchTerm: string,
        loading: boolean,
        sortBy: string,
        sortColumn:string,
        rerender1: boolean,
        totalCount: number
    }
    
    
    const initialLeadState: TLeadState = {
        data: [],
        perPage: 10,
        currentPage: 1,
        totalPage: 1,
        searchTerm: "",
        loading: false,
        sortBy: "desc",
        sortColumn:"",
        rerender1:false,
        totalCount: 0
    
        
    }
    
    export const leadSlice = createSlice({
        name: 'lead',
        initialState:initialLeadState,
        reducers: {
            setLead: (state:TLeadState, { payload }: PayloadAction<[]>) => {
              state.data=payload
             },
            setPerPage: (state:TLeadState, {payload}: PayloadAction<number>) => {
                state.perPage = payload;
            },
              setTotalCount: (state:TLeadState, {payload}: PayloadAction<number>) => {
                state.totalCount = payload;
            },
            setCurrentPage: (state:TLeadState, {payload}: PayloadAction<number>) => { 
                state.currentPage = payload;
            },
            setTotalPage: (state:TLeadState, {payload}: PayloadAction<number>) => {
                state.totalPage = payload
             },
            setSearchTerm: (state:TLeadState, {payload}: PayloadAction<string>) => { 
                state.searchTerm = payload;
            },
            setSortBy: (state:TLeadState, {payload}: PayloadAction<string>) => { 
              state.sortBy = payload;
          },
          setSortColumn: (state:TLeadState, {payload}: PayloadAction<string>) => { 
            state.sortColumn = payload;
            state.sortBy = "desc";
        },
            setLoading: (state:TLeadState, {payload}: PayloadAction<boolean>) => { 
              state.loading = payload
            },
            setRerender: (state:TLeadState, {payload}: PayloadAction<boolean>) => {
                state.rerender1 = payload
             },
        },
    })
    
    
    export const { setLead, setRerender,setPerPage, setCurrentPage, setSortColumn,setSortBy, setTotalPage, setSearchTerm, setLoading , setTotalCount } = leadSlice.actions
    export default leadSlice.reducer
    